import axios from 'axios'
import baseUrl from '../config.json'

export const createrole = (data)=>{
    return axios.post(baseUrl.apiEndPoint+"/api/createrole",data)
}

export const getrole= ()=>{
    return axios.get(baseUrl.apiEndPoint+"/api/getrole")
}
const api = {
    createrole,
    getrole
  }
  export default api